import api from '../api'

export const postFertilizer = (params) => api.post('/admin/fertilizers', params)

export const putFertilizer = ({ id, ...params }) => api.put(`/admin/fertilizers/${ id }`, params)

export const deleteFertilizer = ({ id }) => api.delete(`/admin/fertilizers/${ id }`)

export const postFertilizerManufacturer = (params) => api.post('/admin/fertilizer-makers', params)

export const putFertilizerManufacturer = ({ id, ...params }) => api.put(`/admin/fertilizer-makers/${ id }`, params)